import Logout from "./Logout";
import SuccessView from "./SuccessView";
import { useSessionContext } from "supertokens-auth-react/recipe/session";
import { useNavigate } from "react-router-dom";
import { signOut } from "supertokens-auth-react/recipe/thirdparty";
import React, { useEffect, useState } from 'react'
// TODO: This screen needs to be more professional
export default function LogoutPage() {
    const sessionContext = useSessionContext();
    const navigate = useNavigate();

    async function logoutClicked() {
        debugger;
        await signOut();
        navigate("/auth");
    }

    useEffect(() => {
        logoutClicked().then(console.log);
    }, []); // load once

    if (sessionContext.loading === true) {
        return null;
    }
    // setTimeout(() => {
    //     logoutClicked().then(console.log);
    // }, 400);
    return (
        <div className="fill">
            <Logout logoutClicked={logoutClicked} />
            <SuccessView userId={sessionContext.userId} />
        </div>

    );
}
